angular
  .module('capability-ng-notification-settings')
  .factory('PreferenceBuilder', (Interface: any, PreferenceDTD: any) => {
    function PreferenceDTO(this: any, data: any) {
      Interface.implement(PreferenceDTD, data, this);
    }
    return PreferenceDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/builders/preference_builder.ts